import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useAttendance } from '../../../hooks/Features/useAttendance'
import { itemsPerPage } from '../../../shared/data'
import CustomHeading from '../../CustomHeading'
import CustomPagination from '../../CustomPagination'
import InProgress from '../../InProgress'
import Layout from '../../Layout'
import Loader from '../../Loader'
import CustomTable from '../../Table/CustomTable'
import CustomTableHeading from '../../Table/CustomTableHeading'
import CustomTableRow from '../../Table/CustomTableRow'
import styles from '../reports.module.css'

export default function OutletWiseReport() {
  return (
    <Layout heading="Outlet Wise Report" none>
      <InProgress />
      {/* <CustomTable padding className={styles.table}>
        <CustomTableHeading heading={['OUTLETWISE', 'YESTERDAY', 'MTD', 'QTD']} />
        <CustomTableRow className={styles.subHead}>
          <TableCell></TableCell>
          <TableCell className={styles.subHead1}>
            <TableCell>Lead Number</TableCell>
            <TableCell>Lead Value</TableCell>
          </TableCell>
          <TableCell className={styles.subHead1}>
            <TableCell>Lead Number</TableCell>
            <TableCell>Lead Value</TableCell>
          </TableCell>
          <TableCell>
            <TableCell>Lead Number</TableCell>
            <TableCell>Lead Value</TableCell>
          </TableCell>
        </CustomTableRow>
        <TableBody className={styles.tr}>
          <CustomTableRow>
            <TableCell className={styles.region}></TableCell>
            <TableCell colSpan={3}></TableCell>
          </CustomTableRow>
          <CustomTableRow>
            <TableCell className={styles.region}></TableCell>
            <TableCell colSpan={3}></TableCell>
          </CustomTableRow>
          <CustomTableRow>
            <TableCell className={styles.region}></TableCell>
            <TableCell colSpan={3}></TableCell>
          </CustomTableRow>
          <CustomTableRow>
            <TableCell className={styles.region}></TableCell>
            <TableCell colSpan={3}></TableCell>
          </CustomTableRow>
          <CustomTableRow>
            <TableCell className={styles.region}></TableCell>
            <TableCell colSpan={3}></TableCell>
          </CustomTableRow>
        </TableBody>
      </CustomTable> */}
    </Layout>
  )
}
